<template>
  <modal-structure
    :affirmative-handler="handleAffirmative"
    :negative-handler="handleNegative"
  >
    <template v-slot:header>
      hello
    </template>
    <template v-slot:content>
      <div>
        <h1>This is cool</h1>
        <br>
        <p>this is great</p>
      </div>
    </template>
    <template v-slot:footer />
  </modal-structure>
</template>

<script>
import ModalStructure from './ModalStructure'
export default {

  name: 'TestModal',
  components: {
    ModalStructure
  },

  methods: {
    handleAffirmative () {
      // console.log('you answered in the affirmative:')
    },
    handleNegative () {
      // console.log('you answered in the negative:')
    }
  }
}
</script>
